const utils         = require('frontend-controller/lib/utils');
const SignaturePad  = require('signature_pad/dist/signature_pad.umd.min');

module.exports = {
    config: {
        environmentDependent: true
    },

    model: {
        screen: {
            width: 0,
            height: 0
        },
        enlarged: false,
        shippingOrder: {
            key: '',
            year: 0,
            quarter: 0
        },
        alreadySigned: false
    },

    events: {
        controlButton: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                const self = event.data.component
                const $target = $(event.target).closest('button')

                if($target.hasClass('enlarge')){
                    self.toggleEnlarged()
                } else if($target.hasClass('save')){
                    self.saveSignature()
                } else if($target.hasClass('reset')){
                    self.resetSignature()
                }
            }
        }
    },

    methods: {
        prepare: function(storage, isServer){
            this.model.document = (((storage.request || {}).documentData || {}).meta || {}).document || {}
            this.model.shippingOrderID  = this.model.document.shippingOrderID
            this.model.signature        = this.model.document.signature
            this.model.signedAt         = this.model.document.signedAt
            this.model.alreadySigned    = !!this.model.signature;
        },

        /**
         * this function will be called after all environment dependent components had the change to decide if they want
         * to be refreshed or not. furthermore, this function will be called after the new environment has been set as
         * activeEnvironment.
         */
        onEnvironmentUpdated: function(){
            // this.updateDimensions(this.activeEnvironment.dimensions.screen)

            if(!this.model.alreadySigned){
                this.initSignaturePad()
            }
        },

        updateDimensions: function(screen){
            if(screen){
                const width = Math.max(screen.width, screen.height);
                const height = Math.min(screen.width, screen.height);
                const landscapeRatio = width / height
                this.model.screen = {
                    width,
                    height,
                    landscapeRatio
                }
            }
        },

        initSignaturePad: function(){
            const $element = this.$
            const $sign = $element.find('.sign')
            const $canvas = $element.find('canvas')
            if($sign.length > 0 && $canvas.length > 0){
                const bbox = $sign[0].getBoundingClientRect()
                const canvas = $canvas[0]
                canvas.width = bbox.width;
                canvas.height = Math.floor(bbox.width / this.model.screen.landscapeRatio);

                if(this.model.sp){
                    if(this.model.signature){
                        this.model.sp.fromDataURL(this.model.signature, {
                            ratio: 1
                        })
                    }
                } else {
                    var signatureConfig = {
                        minWidth: .5,
                        maxWidth: 2.5,
                        minDistance: 5
                    }
                    if(this.model.enlarged){
                        signatureConfig.minWidth *= 10;
                        signatureConfig.maxWidth *= 5;
                        signatureConfig.minDistance *= 5;
                    }
                    this.model.sp = new SignaturePad(canvas, signatureConfig)
                    this.model.sp.addEventListener('endStroke', () => {
                        this.model.signature = this.model.sp.toDataURL()
                    }, { once: false });
                }
            }
        },

        toggleEnlarged(){
            this.model.enlarged = !this.model.enlarged;
            if(this.model.enlarged){
                this.$.addClass('enlarged')
            } else {
                this.$.removeClass('enlarged')
            }

            this.initSignaturePad();
        },

        resetSignature(){
            if(!this.model.alreadySigned){
                this.model.signature = '';
                if(this.model.sp){
                    this.model.sp.clear();
                }
            }
        },

        saveSignature(){
            const signature = this.model.sp.toDataURL()

            if(signature && this.model.shippingOrderID){
                this.performAction(
                    this.prepareAction(
                        'sign_shippingOrder',
                        this.model.shippingOrderID,
                        undefined,
                        {
                            source: {
                                submit: {
                                    data: {
                                        data: {
                                            attributes: {
                                                signature
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    )
                ).then(() => {
                    this.model.signature = signature;
                    this.model.signedAt = utils.moment().format();
                    this.refresh(false);

                    // TODO: cleanup this mess when there is time.
                    const $pdfLink = $('a[data-href]')
                    if($pdfLink.length > 0){
                        $pdfLink
                            .attr('href', $pdfLink.data('href'))
                            .css('display', 'block')
                    }

                    var statusController;
                    if((statusController = getComponent('statusController'))){
                        statusController.addPanel('status.done.save');
                    }
                }).fail(error => {
                    console.log(error)
                })
            } else {
                return this.performAction(this.prepareAction('message', undefined, {
                    messageDisplay: {
                        message: 'error:shippingOrder.missingSignature'
                    }
                }));
            }
        },
    },

    hooks: {
        attach: function($element, options){
            if(!this.model.alreadySigned){
                this.updateDimensions(document.body.getBoundingClientRect())
                this.initSignaturePad()
            }
        }
    }
}